import dayjs from 'dayjs'

export const emailRule = (value => {
    return !value || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+){1,5}$/.test(value)
})
export const signupEmailRule = (value => {
    return !value || /^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+)@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+){1,5}$/.test(value)
})
export const passwordRule = (value => {
    return !value || /(?=.*?[A-Z])(?=.*?\d)(?=.*?[!\"#$%&'()*+,-./:;<=>?@[\]^_`{}])[!-~]{8,20}|(?=.*?[a-z])(?=.*?\d)(?=.*?[!\"#$%&'()*+,-./:;<=>?@[\]^_`{}])[!-~]{8,20}|(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[!\"#$%&'()*+,-./:;<=>?@[\]^_`{}])[!-~]{8,20}|(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[!-~]{8,20}/.test(value);
})
export const zenkakuKataKanaRule = function(value){
    return !value || /^[ァ-ヶー]+$/.test(value);
};
export const zenkakuHiraganaRule = (value) => {
    return !value || /^[ぁ-んー]+$/.test(value)
}
export const zenkakuNameRule = (value) => {
    // `\u30a0-\u30ff` カタカナ
    // `\u3040-\u309f` ひらがな
    // `\u3005-\u3006` 々, 〆（記号）
    // `\u30e0-\u9fcf` CJK統合漢字 (彅, 渞, 髙 etc...)
    // `\uFA0E-\uFA2D` CJK互換漢字 The IBM 32 compatibility ideographs (﨎, 﨑, 鶴 etc...)
    // `\uFA30-\uFA6A` CJK互換漢字 JIS X 0213 compatibility ideographs (侮, 頻 etc...)
    // `\uFA6B-\uFA6D` CJK互換漢字 ARIB compatibility ideographs (恵, 舘 etc...)

    return !value || !!value.match(/^[Ａ-Ｚａ-ｚ\u30a0-\u30ff\u3040-\u309f\u3005-\u3006\u30e0-\u9fcf\uFA0E-\uFA2D\uFA30-\uFA6A\uFA6B-\uFA6D]+$/)
}
export const zenkakuRule = (value) => {
    // 全角英数記号ひらがな・カタカナ漢字すべて含む。(半角以外)
    return !value || !!value.match(/^[^\x01-\x7E\uFF65-\uFF9F]+$/)
}
export const zenhankakuRule = (value) => {
    // 全半角英数記号ひらがな・カタカナ漢字すべて含む。
    // サロゲートペアと絵文字は除く
    // ダブルクォーテーションは除く
    return !value || (!!value.match(/^[\u0000-\u0021\u0023-\uD7FF\uE000-\uFFFF]+$/) && !(/\p{Emoji_Modifier_Base}\p{Emoji_Modifier}?|\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu.test(value)))
}
export const zenkakuMaxLength = (size) => (value) => {
    // サロゲートペア文字に対応する
    // null のとき文字列に変換する
    if (value === null) value = ''
    // 𩸽(ほっけ)とか𩹉(とびうお), 絵文字などUnicode番号D800〜DBFFとDC00〜DFFFの組み合わせで表現されている文字列は正しくカウントできない
    // e.g. `'𩸽'.length` とやってしまうと結果は `2` となる
    const l = (value.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]|[^\uD800-\uDFFF]/g) || []).length
    return !value || l <= size
}
export const phoneNumberRule = function(value){
    return !value || /^0[0-9]{9,10}$/.test(value);
};
export const dateRule = function(value){
    // 有効な日付かチェックする
    const format = 'YYYYMMDD';
    return !value || (dayjs(value, format).format(format) === value);
};
export const birthdayRule = (value) => {
    // 未来の日付かチェックする
    const today = dayjs()
    const birthday = dayjs(value)

    return !value || !birthday.isAfter(today)
};
export const jleagueIdRule = function(value){
    // 6〜128文字の半角英数記号 (英字は小文字のみ)
    // メッセージを切り分けるため文字数チェックは vuelidate の `minLength`, `maxLength` を使用する
    return !value || /^[0-9a-zA-Z@_+!*/.-]+$/.test(value);
};
export const loginAndPasswordChangejleagueIdRule = function(value) {
    // & を許容
    return !value || /^[0-9a-zA-Z@_+!*/.&-]+$/.test(value);
};

// vuelidate 使用しているところでは使わない
export const requiredRule = (value) =>  value !== ''
// vuelidate 使用しているところでは使わない
export const zipcodeRule = function(value){
    return !value || /^[0-9]{7}$/.test(value);
};
